import React from 'react';

const SendIcon = () => (
  <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.1244 10.3428L1.96885 0.120155C0.854887 -0.334182 -0.382854 0.574493 0.112243 1.59675L3.2066 9.20691L17.3168 11.365L3.2066 13.5231L0.112243 21.1333C-0.25908 22.1555 0.854887 23.0642 1.96885 22.4963L24.1244 12.2737C24.9908 11.9329 24.9908 10.7971 24.1244 10.3428Z" fill="#1CA5E0" />
  </svg>
);

export default SendIcon;
